import { Fragment, useState, useRef, useEffect } from 'react';
import { isStarted } from 'conversations-async-data/async-data/operators/statusComparators';
import { useThreadDetails } from '../thread-details-feature/public/hooks/useThreadDetails';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIIcon from 'UIComponents/icon/UIIcon';
// @ts-expect-error type not available yet
import { getEmail } from 'conversations-internal-schema/visitor/operators/visitorGetters';
import { getIsBlocked, getIsClosed, getIsFiltered, getOriginalGenericChannelId, getVisitor } from 'conversations-thread-data/thread-details/public/operators';
import { SEND_TRANSCRIPT_PROMPT, BLOCK_THREAD, MOVE_TO_INBOX_PROMPT } from './promptNames';
import MoreActionsPrompts from './MoreActionsPrompts';
import AsyncMoreActionsDropdownOptions from './async/AsyncMoreActionsDropdownOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoreActionsDropdown = ({
  disabled,
  hasEscalationAccess,
  inboxId,
  isClosingCurrentConversation,
  isEscalationPanelOpen = false,
  isGrrPanelOpen = false,
  isKnownVisitor,
  closeThread,
  openEscalationPanel,
  openGrrPanel,
  restoreThread,
  threadId,
  threadDetails,
  properties
}) => {
  const {
    asyncFilterChangeRequest
  } = useThreadDetails({
    threadId
  });
  const [showSendTranscriptPrompt, setSendTranscriptPrompt] = useState(false);
  const [showBlockThreadPrompt, setBlockThreadPrompt] = useState(false);
  const [showMoveToInboxPrompt, setMoveToInboxPrompt] = useState(false);
  const [showMarkAsSpamPrompt, setMarkAsSpamPrompt] = useState(false);
  const [hasBlockBeenClicked, setHasBlockBeenClicked] = useState(false);
  const isVisitorBlocked = getIsBlocked(threadDetails);
  const isThreadClosed = getIsClosed(threadDetails);
  const isThreadFiltered = getIsFiltered(threadDetails);
  const genericChannelId = getOriginalGenericChannelId(threadDetails);
  const visitor = getVisitor(threadDetails);
  const visitorEmailAddress = getEmail(visitor);
  const isLoading = isStarted(asyncFilterChangeRequest);
  const prevIsLoading = useRef(isLoading);
  useEffect(() => {
    if (prevIsLoading.current && !isLoading) {
      setHasBlockBeenClicked(false);
    }
  }, [isLoading]);
  useEffect(() => {
    prevIsLoading.current = isLoading;
  }, [isLoading]);
  const openPrompt = prompt => {
    switch (prompt) {
      case SEND_TRANSCRIPT_PROMPT:
        setSendTranscriptPrompt(true);
        break;
      case BLOCK_THREAD:
        setBlockThreadPrompt(true);
        break;
      case MOVE_TO_INBOX_PROMPT:
        setMoveToInboxPrompt(true);
        break;
      default:
        break;
    }
  };
  const renderContent = () => {
    return /*#__PURE__*/_jsx(AsyncMoreActionsDropdownOptions, {
      hasEscalationAccess: hasEscalationAccess,
      isEscalationPanelOpen: isEscalationPanelOpen,
      isGrrPanelOpen: isGrrPanelOpen,
      isVisitorBlocked: isVisitorBlocked,
      isThreadClosed: isThreadClosed,
      isThreadFiltered: isThreadFiltered,
      isClosingCurrentConversation: isClosingCurrentConversation,
      isCloseConversationDisabled: false,
      openMarkAsSpamPrompt: () => setMarkAsSpamPrompt(true),
      openPrompt: openPrompt,
      closeThread: closeThread,
      restoreThread: restoreThread,
      disabled: disabled,
      threadId: threadId,
      genericChannelId: genericChannelId,
      setBlockClicked: () => setHasBlockBeenClicked(true),
      openEscalationPanel: openEscalationPanel,
      openGrrPanel: openGrrPanel
    });
  };
  if (isLoading && hasBlockBeenClicked) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "extra-small"
    });
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIDropdown, {
      animateOnToggle: true,
      buttonUse: 'tertiary-light',
      buttonSize: "small",
      buttonClassName: "selenium-test-marker-more-actions-dropdown-button",
      Content: renderContent,
      disabled: disabled,
      "data-test-id": "more-actions-dropdown",
      caretRenderer: () => /*#__PURE__*/_jsx(UIIcon, {
        name: "ellipses",
        size: 18,
        style: {
          marginLeft: '-12px'
        }
      }),
      style: {
        width: 20
      }
    }), /*#__PURE__*/_jsx(MoreActionsPrompts, {
      isKnownVisitor: isKnownVisitor,
      threadId: threadId,
      inboxId: inboxId
      /*  @ts-expect-error Jun-5-2024, 19:34UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */,
      genericChannelId: genericChannelId,
      visitorEmailAddress: visitorEmailAddress,
      properties: properties,
      showBlockThreadPrompt: showBlockThreadPrompt,
      showSendTranscriptPrompt: showSendTranscriptPrompt,
      showMoveToInboxPrompt: showMoveToInboxPrompt,
      showMarkAsSpamPrompt: showMarkAsSpamPrompt,
      setBlockThreadPrompt: setBlockThreadPrompt,
      setHasBlockBeenClicked: setHasBlockBeenClicked,
      setSendTranscriptPrompt: setSendTranscriptPrompt,
      setMoveToInboxPrompt: setMoveToInboxPrompt,
      setMarkAsSpamPrompt: setMarkAsSpamPrompt
    })]
  });
};
MoreActionsDropdown.displayName = 'MoreActionsDropdown';
export default MoreActionsDropdown;